import { PathKeys } from "types";

const Paths: { [key in PathKeys]: string } = {
    youtube: "/youtube",
    landing: "/",
    nopage: "*",
};

export default Paths;
